import styled from 'styled-components'


const SectionsContainer = styled.div`
& >section:not(:last-child) {
    border-bottom: 1px solid #C6C6C8;
}
`;

export default SectionsContainer;